"use client";
import Link from "next/link";

export default function Breadcrumb({
  title,
  level1Label,
  level1Href,
  level2Label,
}: Readonly<{
  title: string;
  level1Label: string;
  level1Href: string;
  level2Label: string;
}>) {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: level1Label,
        item: level1Href,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: level2Label,
      },
    ],
  };

  return (
    <>
      <section
        className="hidden !px-4 !py-2 !text-[12px] sm:!px-4 sm:!py-4 sm:!text-[15px] md:block md:!px-6 md:!py-4 lg:!text-[16px]"
        aria-label="Breadcrumb"
      >
        <h3 className="!text-[14px] font-[500] text-black sm:!text-[16px] lg:!text-[20px]">
          {title}
        </h3>
        <Link href={level1Href} className="text-[#FF6700]">
          {level1Label}
        </Link>
        <span className="mx-2 text-[#FF6700]">{" > "}</span>
        <span className="text-black">{level2Label}</span>
      </section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}
